import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppErrorBoundary from './components/AppErrorBoundary';
import { init as initMonitoring } from './services/monitoring';

// Before the app renders, so a failure during that first render is reported
// rather than lost. A no-op unless REACT_APP_SENTRY_DSN was set at build time.
initMonitoring();

const container = document.getElementById('root');

const tree = (
  <React.StrictMode>
    {/* Outside App, so it still catches when the very first render throws. */}
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);

// createRoot, DELIBERATELY, even on the prerendered pages.
//
// The build writes real HTML for every public route (see scripts/prerender.js)
// so a crawler — and the first paint — get the page without running any
// JavaScript. The obvious next step is hydrateRoot, which would adopt that
// markup instead of rebuilding it. It was tried and it does not work here, for
// a reason worth writing down rather than rediscovering:
//
// The prerenderer captures the page AFTER React has settled, which is the only
// point at which the content exists. But several components deliberately show
// nothing on their FIRST render and reveal themselves in an effect — the
// cookie notice reads consent in useEffect precisely so a storage-blocked
// browser cannot throw, and the theme is read the same way. So the captured
// HTML contains a cookie banner and a dark-mode header, while the client's
// first render contains neither. React sees the difference, reports a
// hydration mismatch (#418/#423) and discards the markup anyway.
//
// Hydration could be made to match by restructuring those components around
// the prerenderer. That trade is not worth it: the SEO benefit — a crawler
// receiving real HTML — is already fully banked by the file itself, and this
// way there are no console errors and no half-hydrated states.
ReactDOM.createRoot(container).render(tree);
